import React, { Component } from 'react';

import { getFileName } from 'helpers/FileCaching';
import renderHTML from 'react-render-html';
import classes from './ImageCard.module.scss';

const imageCards = require.context('images/components/Articles/Article/ImageCard', true, /.*\.(gif|png|jpe?g|svg)$/i);

class ImageCard extends Component {

    constructor(props){

        super(props);

    }

    render(){
        let captionText =   <div className={classes['image-card__gradient']}>
                                <h4 className={classes['image-card__caption']}>{renderHTML(this.props.content.caption)}</h4>
                            </div>
        return (

            <div className={classes['image-card']}>

                <div className={`${classes['image-card__ratio_size']} aspect-ratio-box`}>
                    <div className={`aspect-ratio-box-inside`}>
                        <div className={classes['image-card__wrap']}>
                            <img className={classes['image-card__image']} alt={this.props.content.alt} src={getFileName(imageCards, this.props.content.image[this.props.windowSize]) } />
                            {this.props.content.caption ? (captionText) : null}
                        </div>  
                    </div>
                </div>
           
            </div>
        );
    }
}

export default ImageCard;